<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <!-- <md-stepper md-alternate-labels>
      <md-step
        md-label="Shipping summary"
        :md-editable="stepperWidget.quotationId=='' || stepperWidget.quotationId==null?true:false"
        :md-icon="stepperWidget.quotationId=='' || stepperWidget.quotationId==null?'':'done'"
        :md-continue="false"
        :md-active="stepperWidget.quotationId=='' || stepperWidget.quotationId==null?false:true"
      ></md-step>
      <md-step
        md-alternate-labels
        md-label="Assignment Order"
        :md-editable="stepperWidget.assignId=='' || stepperWidget.assignId==null?true:false"
        :md-disabled="stepperWidget.quotationId=='' || stepperWidget.quotationId==null?true:false"
        :md-icon="stepperWidget.assignId=='' || stepperWidget.assignId==null?'':'done'"
        :md-active="stepperWidget.quotationId=='' || stepperWidget.quotationId==null?false:true"
      ></md-step>
      <md-step
        md-label="Vehicle Booking"
        :md-editable="stepperWidget.vehicleBookingId=='' || stepperWidget.vehicleBookingId==null?true:false"
        :md-disabled="stepperWidget.vehicleBookingId=='' || stepperWidget.vehicleBookingId==null?true:false"
        :md-icon="stepperWidget.vehicleBookingId=='' || stepperWidget.vehicleBookingId==null?'':'done'"
      ></md-step>
      <md-step
        md-label="GRN Detail "
        :md-editable="stepperWidget.followActivityId=='' || stepperWidget.followActivityId==null?true:false"
        :md-disabled="stepperWidget.followActivityId=='' || stepperWidget.followActivityId==null?true:false"
        :md-icon="stepperWidget.followActivityId=='' || stepperWidget.followActivityId==null?'':'done'"
      ></md-step>
      <md-step
        md-label="Invoice"
        :md-editable="stepperWidget.invoiceId=='' || stepperWidget.invoiceId==null?true:false"
        :md-disabled="stepperWidget.invoiceId=='' || stepperWidget.invoiceId==null?true:false"
        :md-icon="stepperWidget.invoiceId=='' || stepperWidget.invoiceId==null?'':'done'"
      ></md-step>
    </md-stepper>-->
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSales" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Assignment Form</b-navbar-brand>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="this.salesListData.allModuleId ? this.salesListData.allModuleId : ''"
          :jobSeriesBanner="this.salesListData.salesSeries? this.salesListData.salesSeries:''"
          :bannerClientName="
            this.salesListData.clientName ? this.salesListData.clientName : ''
          "
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <div
              class="phone-viewport"
              id
              v-if="
                (quotationFinal.statusAct == 'Approved' &&
                  assignmentList.assignId != '') ||
                (viewAllAssignment.length == 0 &&
                  quotationFinal.statusAct == 'Approved') ||
                showMainAssign
              "
            >
              <md-layout md-gutter>
                <md-layout md-flex="90"></md-layout>
                <md-layout md-flex="5">
                  <b-button
                    variant="warning"
                    size="sm"
                    :disabled="permissionStatus ? true : false"
                    @click="showMoreItem"
                  >
                    <span>{{
                      showMoreNewItem == true ? "Hide" : "Show More"
                    }}</span>
                  </b-button>
                  <md-spinner
                    md-indeterminate
                    id="loader1"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>
              <md-layout md-gutter v-if="showMoreNewItem == true">
                <!-- <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Sales Booking No.</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="salesId"
                          name="salesId"
                          v-model="assignmentList.salesSeries"
                          disabled
                        ></b-form-input>
                      </md-layout>
                      </md-layout>-->

                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Quotation No.</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="assignQuotationId"
                      id="assignQuotationId"
                      v-model="assignmentList.quotationSeries"
                      disabled
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Client Name</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="clientName"
                      id="clientName"
                      v-model="quotationList.clientName"
                      disabled
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <!-- <md-layout md-flex="15"></md-layout>
                    <md-layout md-flex="20">
                      <md-layout md-flex="100">
                        <label>Assignment Date</label>
                        <b-form-input :formatter="capitalizeAll" id="date" name="date" v-model="assignmentList.date" disabled></b-form-input>
                      </md-layout>
                      </md-layout>-->
              </md-layout>

              <md-layout md-gutter v-if="showMoreNewItem == true">
                <!-- <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <md-layout md-flex="100">
                        <label>Contact Number</label>
                        <b-form-input :formatter="capitalizeAll"
                          v-model="quotationList.clientContact"
                          name="clientContactNumber"
                          id="clientContactNumber"
                          disabled
                        ></b-form-input>
                      </md-layout>
                      </md-layout>-->
                <!-- <md-layout md-flex="15"></md-layout>
                    <md-layout md-flex="20">
                      <md-input-container>
                        <label for="Type">Transport Type</label>
                        <md-select name="type" id="type" v-model="quotationList.type" disabled>
                          <md-option value>Select Type</md-option>
                          <md-option value="Import">Import</md-option>
                          <md-option value="Export">Export</md-option>
                        </md-select>
                      </md-input-container>
                      </md-layout>-->
              </md-layout>
              <md-layout md-gutter  v-if="showMoreNewItem == true">
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Pickup Location</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="fromLocation"
                      id="fromLocation"
                      v-model="assignmentList.fromLocation"
                      disabled
                    ></b-form-input>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Stuffing Location</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="toLocation"
                      id="toLocation"
                      v-model="quotationList.StuffingLocation"
                      disabled
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Handover Location</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="toLocation"
                      id="toLocation"
                      v-model="assignmentList.toLocation"
                      disabled
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
              </md-layout>

              <md-layout md-gutter >
                <!-- <md-layout md-flex="30">
                      <label for="hubId">Vehicle Requried From(HUB)</label>
                      <model-list-select
                        :list="hubList"
                        v-model="assignmentList.hubId"
                        option-value="hubId"
                        option-text="hubName"
                        placeholder="Select Hub"
                      ></model-list-select>

                      <span class="error" v-if="!assignmentList.hubId">{{HubIdError}}</span>
                      </md-layout>-->

                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>No. of Vehicle Requried *</label>
                    <!-- :disabled="assignmentList.assignId != ''" -->
                    <b-form-input :formatter="capitalizeAll"
                      type="number"
                      min="0"
                      name="noOfTrucks"
                      id="noOfTrucks"
                      v-model="assignmentList.noOfTrucks"
                      @keyup="totalCostFinal"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!assignmentList.noOfTrucks">{{
                    noOfTrucksError
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Cargo Weight(in Tons) *</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="cargoWeight"
                      id="cargoWeight"
                      v-model="assignmentList.cargoWeight"
                      :disabled="permissionStatus"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!assignmentList.cargoWeight">{{
                    cargoWeightError
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Booking No.</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="bookingNo"
                      id="bookingNo"
                      v-model="assignmentList.bookingNo"
                      :disabled="permissionStatus"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-gutter style="margin-top:-12px" class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="35">
                      <h4
                        class="showMoreData"
                        @click="checkAvailability"
                        :disabled="permissionStatus?true:false"
                      >Check Vehicle Availability</h4>
                    </md-layout>
                    </md-layout>-->
              <md-layout md-gutter v-if="assignmentList.noOfTrucks > 1">
                <md-layout md-flex="70">
                  <md-checkbox
                    id="my-test9"
                    name="my-test9"
                    v-model="checkCargo"
                    class="md-primary"
                    @change="showMultipleCargo"
                    >Select Cargo Weight if different for multiple
                    truck</md-checkbox
                  >
                </md-layout>
              </md-layout>

              <md-layout md-gutter v-if="multipleCargoValue.length > 0">
                <md-layout
                  md-flex="25"
                  v-for="(item, index) in multipleCargoValue"
                  :key="index"
                >
                  <md-layout md-flex="80">
                    <md-layout md-flex="100">
                      <label>Truck {{ index + 1 }} Cargo Wgt(in Tons)</label>
                      <b-form-input :formatter="capitalizeAll"
                        v-model="multipleCargoValue[index]"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="mt-3">
                <md-layout class="justify-content-center">
                  <b-button
                    variant="primary"
                    @click="vehicleBooking"
                    id="addButtonLoader1111"
                    :disabled="permissionStatus ? true : false"
                    >Save & Proceed</b-button
                  >
                  <md-spinner
                    md-indeterminate
                    id="loader1111"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>
              
              <b-col lg="12">
                <span class="error pull-right" v-if="assignmentList.ExecutionCreated">
                  <b> {{ assignmentList.ExecutionCreated }}</b>
                </span>  
              </b-col>
              
              <b-col lg="12">
                <span class="error pull-right" v-if="assignmentList.ExecutionUpdated">
                  <b> {{ assignmentList.ExecutionUpdated }}</b>
                </span>  
              </b-col>

              
              <!-- <b-col lg="12"> {{ assignmentList }} </b-col> -->
            </div>

            <div class="box" v-if="viewAllAssignment.length > 0">
              <div class="box-header">
                <b-button
                  v-if="
                    ExecConCount != quoationConCount &&
                    quoationConCount < ExecConCount
                  "
                  variant="outline-dark"
                  size="sm"
                  :disabled="
                    $sessionsStorage.get('storeExpireStatus') == '1' ||
                    $sessionsStorage.get('storeExpireStatus') == 'null'
                      ? true
                      : false
                  "
                  @click="goToMain"
                  class="pull-right"
                  >{{ !showMainAssign ? "New" : "Hide" }} Assignment</b-button
                >
                <h3
                  v-if="
                    $sessionsStorage.get('storeExpireStatus') == '1' ||
                    $sessionsStorage.get('storeExpireStatus') == 'null'
                  "
                  style="color: red"
                >
                  Note : Quotation Validity Has been Expired. Cannot Create New
                  Assignment..!
                </h3>
              </div>

              <div class="table-responsive tableMain">
                <table id="quotationDetail" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Assignment</th>
                      <!-- <th>Date</th> -->
                      <th>Location Details</th>

                      <th>Vehicle Details</th>
                      <th>Container Details</th>

                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in viewAllAssignment" :key="index">
                      <td
                        @click="showAssignmentData(item)"
                        class="showMoreData"
                      >
                        {{ item.assignSeries }}
                      </td>

                      <td>
                        <b>Pickup Location :</b>
                        {{ item.PICK }}
                        <br />
                        <b>Factory Location :</b>
                        {{ item.STUFF }}
                        <br />
                        <b>Handover Location :</b>
                        {{ item.HAND }}
                      </td>
                      <td>
                        <b>Vehicle Requried :</b>
                        {{ item.noOfTrucks }}
                        <br />
                        <b>Cargo Weight :</b>
                        {{
                          item.multipleCargoValue == ""
                            ? item.cargoWeight
                            : item.multipleCargoValue
                        }}
                      </td>
                      <td>
                        <b>Container No. :</b>
                        {{ item.AllContainerNo }}
                        <br />
                        <b>Container Type :</b>
                        {{ item.AllContainersType }}
                      </td>
                      <!-- <td>{{ item.date | moment}}</td> -->
                      <!-- <td>{{item.salesPrice}}</td> -->
                      <td>
                        <b-button
                          @click="goToGRN(item)"
                          variant="outline-success"
                          size="sm"
                          >Proceeed To GRN</b-button
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose1"
      ref="addPop1"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop2"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";

import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import BannerComponent from "../../allModuleForm/bannerComponent.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection.js";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Transportation") &&
      this.$sessionsStorage.get("salesBookingId") != "" &&
      this.$sessionsStorage.get("salesBookingId") != undefined &&
      this.$sessionsStorage.get("storeQuotationId") != undefined &&
      this.$sessionsStorage.get("storeQuotationId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vehicle/quotation");
      this.getData();
      if (this.$store.getters.get_Assign_Data.length > 0) {
        Object.assign(
          this.assignmentList,
          this.$store.getters.get_Assign_Data[0]
        );
        this.multipleCargoValue =
          this.$store.getters.get_Assign_Data[0]["multipleCargoValue"];
        this.checkCargo = this.$store.getters.get_Assign_Data[0]["checkCargo"];
        this.$store.dispatch("setAssignData", []);
      }
      this.$sessionsStorage.set("storeVehicleBookingId", "");
    } else {
      this.$router.push({
        path: "/sales/salesBooking",
      });
    }
  },
  data() {
    return {
      isLoading: false,
      hubMaster: ["gfdg"],
      salesListData:{},
      buttonStatus: {
        submitBtn: false,
        statusDropDown: false,
      },
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") !== undefined &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,

      statusQId: "",
      assignId: "",
      quotationList: {
        clientName: "",
        clientContactNumber: "",
        salesBookingDate: "",
        fromLocation: "",
        toLocation: "",
        StuffingLocation: "",
        type: "",
        transportDetail: "",
        otherDetail: "",
        comment: "",
        salesSeries: "",
        containerQuantity: "",
        containerTypeId: "",
        containerType: "",
        containerQuantity: "",
        multipleContainerType: "",
      },
      checkCargo: false,
      multipleCargoValue: [],
      containerTypeDetail: [],
      stepperWidget: {},
      alert: {
        content: "a",
        ok: "ok",
      },
      statusList: [
        {
          statusText: "Approved",
          statusVal: "Approved",
        },
        {
          statusText: "Rejected",
          statusVal: "Rejected",
        },
        {
          statusText: "On Hold",
          statusVal: "on Hold",
        },
      ],
      containerEqualTruck: "",
      quotationFinal: {
        advanceCash: "",
        baseCost: "",
        dieselRate: "",
        distance: "",
        driverExpense: "500",
        noOffDay: "",
        quotationId: "",
        status: "Sent For Approval",
        tollPrice: "",
        truckAverage: "3.5",
        quotemargin: "100",
        quoteSalesCost: "",
        quotationSeries: "",
        statusAct: "",
      },
      quoationConCount: "",
      quoationVehicleCount: "",
      ExecConCount: "",
      showMoreNew: false,
      showMoreNewItem: false,
      assignmentList: {
        vehicleAdded: "",
        bookingNo: "",
        JobType: [],
        fromLocation: "",
        toLocation: "",
        salesBookingId: "",
        storeQuotationId: "",
        salesSeries: "",
        quotationSeries: "",
        viaRoute: "",
        cargoWeight: "",
        noOfTrucks: "",
        salesPrice: "",
        taxes: "",
        date: "",
        totalCost: "",
        clientId: this.$sessionsStorage.get("clientId"),
        assignId: "",
        hubId: "",
        StuffingLocation: "",
        containerQuantity: "",
        ExecutionCreated: "",
        ExecutionUpdated: "",
      },
      driverExpenseError: "",
      baseCostError: "",
      dieselRateError: "",
      tollPriceError: "",
      noOffDayError: "",
      distanceError: "",
      statusError: "",

      assignstatusError: "",

      cargoWeightError: "",
      noOfTrucksError: "",
      marginError: "",
      HubIdError: "",

      truckAverageError: "",

      quotemarginError: "",
      advanceCashError: "",
      quoteSalesCostError: "",
      showJobType: [],
      validateQuotation: true,
      validateAssignment: true,
      JobType: [],
      hubMaster: [],
      isActive: true,
      isActiveAssignment: false,
      viewAllAssignment: [],
      UserDetail: {},
      showMainAssign: false,
    };
  },

  mounted() {},
  beforeDestroy() {
    this.$sessionsStorage.set("hubLocationMaster", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    BannerComponent
  },
  computed: {
    hubList() {
      return this.hubMaster;
    },
    userLevel() {
      return this.$sessionsStorage.get("userLevel") == "1" ? true : false;
    },
  },
  filters: {
    moment(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
  },
  methods: {
    goToGRN(item1) {
      console.log('PS Sinha=>',item1)
      this.$sessionsStorage.set("storeAssignId", item1.assignId);
      if(item1.transportType=="Domestic"){
        this.$router.push({
          path: "/vehicle/domesticGRN",
        });
      }else{
        this.$router.push({
          path: "/vehicle/vehicleBooking",
        });
      }
      
    },

    // JqueryFun() {
    //   return $(function() {
    //     return $("#quotationDetail").DataTable();
    //   });
    // },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    onChangeStatus() {
      if (this.statusQId != "") {
        this.buttonStatus.submitBtn = false;
      } else {
        this.buttonStatus.submitBtn = true;
      }
    },

    showMultipleCargo() {
      if (this.checkCargo == false) {
        this.checkCargo = true;
      } else {
        this.checkCargo = false;
      }

      if (this.assignmentList.noOfTrucks != "" && this.checkCargo == true) {
        for (let i = 0; i < this.assignmentList.noOfTrucks; i++) {
          this.multipleCargoValue[i] = this.assignmentList.cargoWeight;
        }
      } else {
        this.multipleCargoValue = [];
      }
    },
    onClose1(type) {
      this.$router.push({
        path: "/vehicle/vehicleBooking",
      });
    },
    showMoreItem() {
      if (this.showMoreNewItem == false) {
        this.showMoreNewItem = true;
      } else {
        this.showMoreNewItem = false;
      }
    },

    showMore() {
      if (this.showMoreNew == false) {
        this.showMoreNew = true;
      } else {
        this.showMoreNew = false;
      }
    },
    onClose(type) {
      if (type != "cancel") {
        this.buttonStatus.statusDropDown = true;
        $("#showAssignment").css("display", "block");
        this.isActiveAssignment = true;
        if (this.isActive != false) {
          $("#Quoationcheck").removeClass("md-active");
          this.isActive = false;
          window.scrollTo(0, 0);
        }
      }
    },
    validateQuotationForm() {
      let validate_new = true;

      if (this.quotationFinal.driverExpense == "") {
        $("#driverExpense").focus();
        this.driverExpenseError = "Enter your expenses";
        validate_new = false;
      }
      if (
        (this.quotationFinal.status == "" ||
          this.quotationFinal.status == "Sent For Approval") &&
        this.$sessionsStorage.get("userLevel") == "1"
      ) {
        $("#quotstatus").focus();
        this.statusError = "Select  status";
        validate_new = false;
      }

      if (this.quotationFinal.truckAverage == "") {
        $("#truckAverage").focus();
        this.truckAverageError = "Enter your truck average";
        validate_new = false;
      }
      if (this.quotationFinal.noOffDay == "") {
        $("#noOffDay").focus();
        this.noOffDayError = "Enter your no of day";
        validate_new = false;
      }
      if (this.quotationFinal.distance == "") {
        $("#distance").focus();
        this.distanceError = "Enter your distance";
        validate_new = false;
      }
      if (this.quotationFinal.dieselRate == "") {
        $("#dieselRate").focus();
        this.dieselRateError = "Enter your diesel rate";
        validate_new = false;
      }
      if (this.quotationFinal.tollPrice == "") {
        $("#tollPrice").focus();
        this.tollPriceError = "Enter your toll price";
        validate_new = false;
      }
      if (this.quotationFinal.quotemargin == "") {
        $("#quotemargin").focus();
        this.quotemarginError = "Enter your margin";
        validate_new = false;
      }
      if (this.quotationFinal.advanceCash == "") {
        $("#advanceCash").focus();
        this.advanceCashError = "Enter Advance Cash";
        validate_new = false;
      }

      if (this.quotationFinal.quoteSalesCost == "") {
        $("#quoteSalesCost").focus();
        this.quoteSalesCostError = "Enter your sales cost";

        validate_new = false;
      }

      if (validate_new != true) {
        this.validateQuotation = false;
      } else {
        this.validateQuotation = true;
      }
    },
    checkAvailability() {
      this.assignmentList["multipleCargoValue"] = this.multipleCargoValue;
      this.assignmentList["checkCargo"] = this.checkCargo;
      let _Array = [this.assignmentList];

      this.$store.dispatch("setAssignData", _Array);
      this.$router.push({
        path: "/vehicle/vehicleAvailability",
      });
    },

    previousSales() {
      window.history.go(-1);
    },

    expandEvent(e) {
      e.preventDefault();
    },
    showAssignmentOrder() {
      this.validateQuotationForm();

      if (this.validateQuotation != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let new_data = {
          salesBookingId: this.$sessionsStorage.get("salesBookingId"),
          clientId: this.$sessionsStorage.get("clientId"),
          driverExpense: this.quotationFinal.driverExpense,
          distance: this.quotationFinal.distance,
          noOffDay: this.quotationFinal.noOffDay,
          tollPrice: this.quotationFinal.tollPrice,
          dieselRate: this.quotationFinal.dieselRate,
          baseCost: this.quotationFinal.baseCost,
          truckAverage: this.quotationFinal.truckAverage,
          status: this.quotationFinal.status,
          quoteSalesCost: this.quotationFinal.quoteSalesCost,
          quotemargin: this.quotationFinal.quotemargin,
          quotationId: this.quotationFinal.quotationId,
          advanceCash: this.quotationFinal.advanceCash,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Transport/addEditQuotation.php`,
          data: JSON.stringify(new_data),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Added Successfully";
                this.quotationFinal.quotationSeries = data.quotationSeries;
              } else {
                this.alert.content = "Data Updated Successfully";
              }

              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              this.quotationFinal.quotationId = data.quotationId;
              this.$sessionsStorage.set("storeQuotationId", data.quotationId);

              this.statusQId = data.quotationId;
              this.showAssignmentData(null);

              this.buttonStatus.submitBtn = false;
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {});
      }
    },

    addClient() {
      this.$router.push({
        path: "/client/addClient",
        name: "Add Clients",
      });
    },
    finalbasecost() {
      let driverExpensenew =
        parseFloat(this.quotationFinal.driverExpense) *
        parseFloat(this.quotationFinal.noOffDay);

      let averageTrucknew =
        parseFloat(this.quotationFinal.distance) /
        parseFloat(this.quotationFinal.truckAverage);

      let dieselRatenew =
        parseFloat(averageTrucknew) *
        parseFloat(this.quotationFinal.dieselRate);
      let basefinalcost =
        parseFloat(dieselRatenew) +
        parseFloat(driverExpensenew) +
        parseFloat(this.quotationFinal.tollPrice);
      this.quotationFinal.baseCost = basefinalcost.toFixed(2);

      let finalSalesCost =
        (parseFloat(this.quotationFinal.baseCost) *
          parseFloat(this.quotationFinal.quotemargin)) /
        100;
      let finalSalesCost2 =
        finalSalesCost + parseFloat(this.quotationFinal.baseCost);
      this.quotationFinal.quoteSalesCost = finalSalesCost2.toFixed(2);
    },
    checkdate() {},

    validateAssignForm() {
      let validate_new = true;

      // if (this.assignmentList.hubId == "") {
      //   $("#HubId").focus();
      //   this.HubIdError = "Please Select Hub";
      //   validate_new = false;
      // }

      if (this.assignmentList.cargoWeight == "") {
        $("#cargoWeight").focus();
        this.cargoWeightError = "Enter your cargo weight";
        validate_new = false;
      }
      if (this.assignmentList.noOfTrucks == "") {
        $("#noOfTrucks").focus();
        this.noOfTrucksError = "Enter your no of truck";
        validate_new = false;
      }
      if (this.assignmentList.margin == "") {
        $("#margin").focus();
        this.marginError = "Enter your margin";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validateAssignment = false;
      } else {
        this.validateAssignment = true;
      }
    },

    // Common function to get total trucks count from viewAllAssignment
    getTotalTrucksCount() {
      if (!this.viewAllAssignment || this.viewAllAssignment.length === 0) {
        return 0;
      }
      
      let totalTrucks = 0;
      this.viewAllAssignment.forEach(function(assignment) {
        if (assignment.noOfTrucks) {
          totalTrucks += parseInt(assignment.noOfTrucks) || 0;
        }
      });
      
      return totalTrucks;
    },

  

    totalCostFinal() {
      if (this.assignmentList.assignId) {
        if (this.assignmentList.vehicleAdded) {
          let addedGRN = this.assignmentList.vehicleAdded.split(",").length;
          if (parseInt(this.assignmentList.noOfTrucks) < parseInt(addedGRN)) {
            this.alert.content =
              "No. of Vehicle Required is less than already added GRN";
            this.$refs["addPop2"].open();
            this.assignmentList.noOfTrucks =
              this.viewAllAssignment[0].noOfTrucks;
            return false;
          }
          if (
            parseInt(this.assignmentList.noOfTrucks) >
            parseInt(this.containerEqualTruck)
          ) {
            this.alert.content =
              "No. of Vehicle Required are more than Available Containers..! ";
            this.$refs["addPop2"].open();
            this.assignmentList.noOfTrucks =
              this.viewAllAssignment[0].noOfTrucks;
            return false;
          } else {
            console.log("vehicle Count Match");
            return true;
          }
        }else if (
            parseInt(this.getTotalTrucksCount()) >
            parseInt(this.ExecConCount)
          ) {
            this.alert.content =
              "No. of Vehicle Required are more than Available Containers..! ";
            this.$refs["addPop2"].open();
            this.assignmentList.noOfTrucks =
              this.viewAllAssignment[0].noOfTrucks;
            return false;
          } else {
            console.log("vehicle Count Match");
            return true;
          }
      } else {
        if (this.viewAllAssignment.length <= 0) {
          if (
            parseInt(this.assignmentList.noOfTrucks) >
            parseInt(this.containerEqualTruck)
          ) {
            this.alert.content =
              "No. of Vehicle Required are more than Available Containers..! ";
            this.$refs["addPop2"].open();
            this.assignmentList.noOfTrucks = "";
            return false;
          } else {
            console.log("vehicle Count Match");
            return true;
          }
        } else {
          let vehicleReq =
            parseInt(this.assignmentList.noOfTrucks) +
            parseInt(this.quoationVehicleCount);
          if (vehicleReq > this.ExecConCount) {
            this.alert.content =
              "No. of Vehicle Required are more than Available Containers..! ";
            this.$refs["addPop2"].open();
            this.assignmentList.noOfTrucks = "";
            return false;
          } else {
            console.log("vehicle Count Match");
            return true;
          }
        }
      }
      return true;
    },
    selectStatus() {
      if ((this.assignmentList.status == "New", "inProgress")) {
        this.assignId = "";
      }
    },

    vehicleBooking() {
      if (!this.totalCostFinal()) {
        return; // Stop execution if validation fails
      }
      if (this.checkCargo == true) {
        this.assignmentList["multipleCargoValue"] = this.multipleCargoValue;
      } else {
        this.assignmentList["multipleCargoValue"] = "";
      }
      this.validateAssignForm();
      if (this.validateAssignment != false) {
        $("#addButtonLoader1111").css("display", "none");
        $("#loader1111").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Transport/addAssignOrder.php`,
          data: JSON.stringify(this.assignmentList),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              this.$sessionsStorage.set("storeAssignId", data.assignId);
              this.assignmentList.assignId = data.assignId;

              $("#addButtonLoader1111").css("display", "block");
              $("#loader1111").css("display", "none");
              this.$refs["addPop1"].open();
            }
          })
          .catch((error) => {});
      }
    },
    showAssignmentData(data) {
      let currentDate = new Date();
      if (data) {
        Object.keys(data).map((keys) => {
          this.assignmentList[keys] = data[keys] || "";
        });

        if (data.multipleCargoValue != "" && data.multipleCargoValue != null) {
          this.multipleCargoValue = data.multipleCargoValue.split(",");
          this.checkCargo = true;
        }

        window.scrollTo(0, document.body.scrollHeight);
      } else {
        this.assignmentList.date = this.formatDate(currentDate);
      }

      this.assignmentList.salesBookingId =
        this.$sessionsStorage.get("salesBookingId");
      this.assignmentList.storeQuotationId =
        this.$sessionsStorage.get("storeQuotationId");
      this.assignmentList.fromLocation = this.quotationList.fromLocation;
      this.assignmentList.toLocation = this.quotationList.toLocation;
      this.assignmentList.salesPrice = this.quotationFinal.quoteSalesCost;
      this.assignmentList.quotationSeries = this.quotationFinal.quotationSeries;
      this.assignmentList.salesSeries = this.quotationList.salesSeries;
      this.quotationFinal.statusAct = this.quotationFinal.status;
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");
      let minuteNew = [Hour, minute].join(":");

      return dateNew + " " + minuteNew;
    },

    getLatlng(addr) {
      let obj = {};

      addr = addr.replace(/\s+/g, "+");

      let _url =
        "https://maps.googleapis.com/maps/api/geocode/json?&address=" +
        addr +
        "&key=AIzaSyCFDNm64Tvl2XJ7MO59T4ontvFxi7D4_p0";
      let options = {
        method: "GET",
        url: _url,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      axios(options).then((res) => {
        const {
          data: { results, status },
        } = res;

        if (results.length > 0 && status == "OK") {
          Object.assign(obj, results[0].geometry.location);
        }
      });
      return obj;
    },
    goToMain() {
      this.showMainAssign = this.showMainAssign ? false : true;
    },

    getData() {
      this.isLoading = true;
      let currentDate = new Date();
      this.showJobType = [
        {
          value: "FF",
          show: "FF",
          flex: "10",
        },
        {
          value: "CC",
          show: "CC",
          flex: "10",
        },
        {
          value: "Trucking",
          show: "Trucking",
          flex: "15",
        },

        {
          value: "Yard",
          show: "Yard",
          flex: "10",
        },
        {
          value: "All",
          show: "All",
          flex: "10",
        },
      ];

      this.JobType = Array(this.showJobType.length).fill(false);

      this.statusQId =
        this.$sessionsStorage.get("storeQuotationId") == "false"
          ? ""
          : this.$sessionsStorage.get("storeQuotationId");

      this.assignId =
        this.$sessionsStorage.get("storeAssignId") == "false"
          ? ""
          : this.$sessionsStorage.get("storeAssignId");

      let new_data = {
        salesBookingId: this.$sessionsStorage.get("salesBookingId"),
        quotationId: this.statusQId,
        assignId: this.assignId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/quotatonSales.php`,
        data: JSON.stringify(new_data),

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          if (result && result.status == 200) {
            let data = result.data;
            if (data.salesList.length > 0) {
              this.salesListData = data.salesList[0];
              Object.keys(data.salesList[0]).map((x) => {
                this.quotationList[x] = data.salesList[0][x] || "";
                if (x == "jobType") {
                  this.quotationList[x] = data.salesList[0][x].split(",");
                }
                if (x == "multiConNo") {
                  let conDummy = data.salesList[0].multiConNo.split(",");

                  let dummyIntCon = 0;
                  for (let i = 0; i < conDummy.length; i++) {
                    let newVal1 = parseInt(conDummy[i]) + parseInt(dummyIntCon);
                    dummyIntCon = newVal1;
                  }
                  this.ExecConCount = dummyIntCon;
                  if (
                    data.salesList[0].multiConNo != null &&
                    data.salesList[0].multiConNo != ""
                  ) {
                    let noOfCont = 0;
                    let noOfContA = data.salesList[0].multiConNo.split(",");
                    for (let k = 0; k < noOfContA.length; k++) {
                      noOfCont = noOfCont + parseFloat(noOfContA[k]);
                    }
                    this.containerEqualTruck = noOfCont;
                  }
                }
              });

              if (data.distancegps != "") {
                this.quotationFinal.distance = data.distancegps;
              }

              this.quotationFinal.dieselRate = data.dieselRate;

              this.showJobType.map((x, index) => {
                let i = this.quotationList.jobType.indexOf(x.value);
                i >= 0
                  ? (this.JobType[index] = true)
                  : (this.JobType[index] = false);
              });
            }

            if (this.$sessionsStorage.get("storeQuotationId") != "false") {
              this.quotationFinal = data.quotationList[0];
              this.quotationFinal.statusAct = data.quotationList[0].status;

              if (this.$sessionsStorage.get("storeQuotationId") != "false") {
                this.buttonStatus.statusDropDown = true;
                $("#showAssignment").css("display", "block");
                this.isActiveAssignment = true;
                if (this.isActive != false) {
                  $("#Quoationcheck").removeClass("md-active");
                  this.isActive = false;
                  window.scrollTo(0, 0);
                }

                if (data.assignList.length > 0) {
                  this.viewAllAssignment = data.assignList;
                  let initialVal = 0;
                  let initialVal2 = 0;
                  for (let r = 0; r < this.viewAllAssignment.length; r++) {
                    if (this.viewAllAssignment[r].totalConCount != null) {
                      let newVal =
                        parseInt(this.viewAllAssignment[r].totalConCount) +
                        parseInt(initialVal);
                      initialVal = newVal;
                    }
                    if (this.viewAllAssignment[r].noOfTrucks != null) {
                      let newVal1 =
                        parseInt(this.viewAllAssignment[r].noOfTrucks) +
                        parseInt(initialVal2);
                      initialVal2 = newVal1;
                    }
                  }
                  this.quoationConCount = initialVal;
                  this.quoationVehicleCount = initialVal2;
                } else {
                  this.viewAllAssignment = [];
                }

                if (this.assignId !== "") {
                  this.showAssignmentData(null);
                } else {
                  this.showAssignmentData(null);

                  let hubval =
                    this.$sessionsStorage.get("hubLocationMaster") != "" &&
                    this.$sessionsStorage.get("hubLocationMaster") != undefined
                      ? this.$sessionsStorage.get("hubLocationMaster")
                      : "";

                  if (hubval != "") {
                    this.hubId = hubval;
                  }
                }
              }
            } else {
              this.quotationFinal.tollPrice = data.tollCost;
            }

            let from = this.getLatlng(this.quotationList.fromLocation);
            let to = this.getLatlng(this.quotationList.toLocation);

            this.quotationFinal.dieselRate = data.dieselRate;
            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.date-mrg {
  margin-top: -24px;
}
.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// quotation.vue?676826a7